import React from 'react';
const rows = [['A night planning before every practice', "Pick up tomorrow's card"], ['Making up drills on the field', '142 practices, sequenced by week'], ['Half the team standing in line', 'Stations so everyone is moving'], ['Digging through the binder mid-practice', "The day's card is on the clipboard"], ['A blank page in week one', 'Day one already mapped out']];
export function CostOfInaction() {
  return <section className="w-full bg-navy-deep" data-id="element-59" data-mp="34via718t6sm2">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-60" data-mp="38xlkhmjqrr5r">
        <h2 className="text-center font-display font-bold uppercase text-white text-3xl sm:text-4xl" data-id="element-61" data-mp="38vsfscsovh0e">
          What another make-it-up-as-you-go season costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-navy-line" data-id="element-62" data-mp="3imdd7wwmmfhq">
          <div className="grid grid-cols-2 bg-navy-mid text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-63" data-mp="3nnaso1q94vfj">
            <div className="border-r border-navy-line px-3 py-2.5 text-crimson-soft" data-id="element-64" data-mp="3smdxbl2bkzmz">
              Without the system
            </div>
            <div className="px-3 py-2.5 text-gold" data-id="element-65" data-mp="3ee3jl6vpoa5f">With Sideline Ready</div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-navy-line text-[12.5px] sm:text-sm" data-id="element-66" data-mp="34hqsmgrjwaed">
              <div className="border-r border-navy-line px-3.5 py-3.5 text-white/60 line-through decoration-crimson/50" data-id="element-67" data-mp="30ihw5454lyf4">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-white" data-id="element-68" data-mp="3s7l5gybvdyym">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}